<div [ngClass]="cls"><ng-content></ng-content></div>
